module.exports = __webpack_public_path__ + "img/dj.44140696.svg";